import publicConfig from "../public-config.js";

import { request as httpRequest } from "./http-library.js";

const calendarHost = publicConfig.external_address;

const CalendarAvailabilityApi = {
  /**
   * Check if the host needs to update their calendar
   * Returns a payload of dates that need updating if applicable.
   * Example payload:
   * {
   *   "sso_id": "66f6d1cd203fbf1da2e64a4a",
   *   "space_id": "67064643c1866d83e8d02136",
   *   "survey_type": "FEB25_AVAILABILITY_CONFIRMATION",
   *   "confirmation_needed": true,
   *   "dates": [
   *     { "date": "2025-03-01", "availability": "available" },
   *     { "date": "2025-03-08", "availability": "partially-booked" },
   *     { "date": "2025-03-15", "availability": "fully-booked" },
   *     { "date": "2025-03-22", "availability": "available" }
   *   ]
   * }
   */
  checkIfCalendarNeedsUpdate: async (ssoId, token) => {
    const params = {
      host: calendarHost,
      method: "GET",
      path: `/v1/calendar/survey/${ssoId}/availability`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    return new Promise((resolve) => {
      httpRequest(params, (res) => {
        if (res.error) {
          analytics.track("http error", {
            location: "CalendarAvailabilityApi.checkIfCalendarNeedsUpdate",
            error: res.error,
          });

          resolve({ confirmation_needed: false });
        } else {
          resolve(res);
        }
      });
    });
  },

  /**
   * Confirm availability
   * Sends a PUT request with a confirmation status.
   */
  confirmCalendarAvailability: async (ssoId, token) => {
    const params = {
      host: calendarHost,
      method: "PUT",
      path: `/v1/calendar/survey/${ssoId}/availability`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const body = { confirmed: true };

    return new Promise((resolve) => {
      httpRequest(
        params,
        (res) => {
          if (res.error) {
            analytics.track("http error", {
              location: "CalendarAvailabilityApi.confirmCalendarAvailability",
              error: res.error,
            });
            resolve();
          } else {
            resolve(res);
          }
        },
        body,
      );
    });
  },
};

export default CalendarAvailabilityApi;
